var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeliveryVan = function SvgDeliveryVan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.833.833H0v15h7.5V2.5c0-.92-.746-1.667-1.667-1.667ZM19.54 9.254 16.547 7.76l-.74-2.96A.832.832 0 0 0 15 4.166H9.166V15c0 .458.043.833.043.833.21 1.87 1.783 3.334 3.708 3.334 1.925 0 3.497-1.464 3.707-3.334h2.543c.46 0 .833-.373.833-.833v-5a.834.834 0 0 0-.46-.746ZM12.916 17.5a2.086 2.086 0 0 1-2.084-2.083c0-1.15.935-2.084 2.084-2.084 1.148 0 2.083.935 2.083 2.084s-.935 2.083-2.083 2.083Zm-2.084-9.167v-2.5h3.62l.547 2.5h-4.167Z",
    fill: "#D64309"
  })));
};
export default SvgDeliveryVan;